import React, { useState, useEffect, useLayoutEffect } from 'react';
import * as actionCreators from '../../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Alert, Button, Fade, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { yesNoOptions, validatePatent } from './../../utilities';
import { faGear, faIdCard, faMotorcycle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Inputs from '../../Components/Inputs';

function VehicleData({ vehicleData, firstStep, codpmpol, saveVehicleData, brands, models, company, saveError, resetError, opcEnabled }) {
  const { errorDescription, alertData, client } = saveError;
  const [mensaje, setMensaje] = useState(null);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const regex = (data) => {
    const regex = /^[a-zA-Z0-9]*$/;
    if (regex.test(data)) {
      return false;
    }
    return true;
  }

  const handleClose = () => {
    resetError(codpmpol);
    setShow(false);
  };

  const verifyForm = () => {
    const requiredPat = opcEnabled.find(opc => opc['cod-emp'] === company && opc['pat-ppc']) ? true : false;
    if (!vehicleData.patent) {
      if (!vehicleData.isNew && requiredPat) {
        setMensaje('Complete su patente');
        return false;
      }
    }
    if (vehicleData.patent) {
      if (company !== 1 || company !== 51) {
        if (!validatePatent(vehicleData.patent)) {
          setMensaje('Caracteres incorrectos, revise la patente');
          return false;
        }
      } else {
        if (vehicleData.patent.length < 5 || vehicleData.patent.length > 7) {
          setMensaje('Caracteres incorrectos, revise la patente')
          return false;
        }
        if (regex(vehicleData.patent)) {
          setMensaje('La patente debe incluir números y letras')
          return false;
        }
      }
      if (vehicleData.registeredPatent?.includes(vehicleData.patent.toUpperCase())) {
        setMensaje('El cliente ya cuenta con un seguro para esta patente')
        return false;
      }
    }
    if (!vehicleData.motor) {
      setMensaje('Complete el número de motor');
      return false;
    }
    if (vehicleData.motor) {
      if (regex(vehicleData.motor)) {
        setMensaje('La identificación de motor debe incluir números y letras')
        return false;
      }
    }
    if (!vehicleData.chassis) {
      setMensaje('Complete el chasis');
      return false;
    }
    if (vehicleData.chassis) {
      if (vehicleData.chassis.length !== 17) {
        setMensaje('Caracteres incorrectos, revise el chasis');
        return false;
      }
      if (regex(vehicleData.chassis)) {
        setMensaje('El chasis debe incluir números y letras')
        return false;
      }
    }
    return true;
  };

  const handleSubmit = async () => {
    if (verifyForm()) {
      setError(false);
      setIsLoading(true);
      const cleanPatient = vehicleData.patent === 'A123BCD' ? '' : vehicleData.patent
      await saveVehicleData({ ...vehicleData, patent: cleanPatient.toUpperCase(), company }, codpmpol);
      setIsLoading(false);
    } else {
      setError(true);
    }
  };

  useEffect(() => {
    codpmpol === "" && navigate("/");
  }, []);

  useEffect(() => {
    try {
      if (errorDescription) {
        if (errorDescription === codpmpol) {
          //La respuesta del back fue positiva y puede ir al pago
          resetError(codpmpol);
          navigate('/qs/payMethod');
        } else {
          setShow(true);
        }
      }
    } catch (error) {
      // console.log(error)
    }
  }, [errorDescription]);

  return (
    <>
      <Fade appear in>
        <div className="qs">
          <div className="container max-shadow">
            <div className='d-flex flex-column m-0 mx-0 mb-4 scroll-off'>
                <h1 className='text-start mx-0 mt-3 fs-5 color-title-blue'>PEDIDO DE COBERTURA / DATOS VEHÍCULO</h1>
                <p className='m-0 fw-semibold color-title-blue'>Presupuesto n° {codpmpol}</p>
              </div>
            <div className="qs-inputs row row-cols-2">
              <Inputs
                title={"Marca"}
                name={'brand'}
                value={brands.find(b => b.value === firstStep.brand)?.label}
                step={'vehicleData'}
                disabled
              />
              <Inputs
                title={"Suma Asegurada"}
                name={'sumAssured'}
                value={firstStep.sumAssured}
                step={'vehicleData'}
                disabled
              />
              <Inputs
                title={"Año"}
                name={'year'}
                type={'number'}
                value={firstStep.year}
                step={'vehicleData'}
                disabled
              />
              <Inputs
                title={"Modelo"}
                name={'model'}
                value={models.find(m => m.value === firstStep.model)?.label}
                step={'vehicleData'}
                disabled
              />
              {(company !== 2 && company !== 52) &&
                <Inputs
                  title={"¿Es 0km ?"}
                  name={'isNew'}
                  type={'select'}
                  options={yesNoOptions}
                  value={vehicleData.isNew}
                  step={'vehicleData'}
                />
              }
              <Inputs
                title={"Chasis"}
                name={'chassis'}
                value={vehicleData.chassis}
                step={'vehicleData'}
                icon={<FontAwesomeIcon icon={faGear} />}
              />
              <div className='d-flex flex-column m-0'>
                <Inputs
                  title={"Patente"}
                  name={'patent'}
                  value={vehicleData.patent}
                  step={'vehicleData'}
                  className={'upper'}
                  icon={<FontAwesomeIcon icon={faIdCard} />}
                />
                <small>En ausencia de la patente real del cliente, avanzar dejando el campo vacío.</small>
              </div>
              <Inputs
                title={"Motor"}
                name={'motor'}
                value={vehicleData.motor}
                step={'vehicleData'}
                icon={<FontAwesomeIcon icon={faMotorcycle} />}
              />
            </div>
            {
              error &&
              <Alert className='mt-2' variant={'danger'}>
                {mensaje}
              </Alert>
            }
            <div className='row'>
              <div className="col-sm-6 col-lg-4 offset-lg-4">
                <Inputs
                  type={'button'}
                  title="Continuar"
                  onClick={handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </Fade>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>¡Aviso!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{errorDescription || client}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} className="main-btn">
            Entiendo
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

function mapStateToProps(state) {
  return {
    vehicleData: state.mainReducer.vehicleData,
    firstStep: state.mainReducer.firstStep,
    codpmpol: state.mainReducer.codpmpol,
    brands: state.mainReducer.moto.motoBrand,
    models: state.mainReducer.moto.motoModel,
    company: state.mainReducer.company,
    opcEnabled: state.mainReducer.opcEnabled,
    saveError: state.mainReducer.saveError,
  };
};

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleData);
